<script setup lang="ts">
import type { Lesson } from '../../model/lessons/interfaces'

import { faCalendar, faCheck, faClockRotateLeft, faPencil, faTrashCan, faXmark } from '@fortawesome/pro-regular-svg-icons'

import { AppDropdown, AppDropdownItem } from '@shared/ui/dropdowns'
import { BtnIcon } from '@shared/ui/buttons'

import { useLessonActions } from '../../model/lessons/lesson-actions.hook'

defineOptions({
  name: 'LessonActions',
})

const props = defineProps<{
  lesson: Lesson
  editUrl: string
}>()

const {
  isOpen,
  containerRef,
  floatingRef,
  floatingStyles,
  triggerIcon,
  refCanApproveJoin,
  refCanViewChangelog,
  refCanDelete,
  refIsDeleteDisabled,
  refCanManage,
  refIsChangeDisabled,
  toggle,
  openEdit,
  approveJoin,
  openChangelog,
  openDelete,
  openReschedule,
  openCancel,
} = useLessonActions({
  lesson: computed(() => props.lesson),
  editUrl: computed(() => props.editUrl),
})
</script>

<template>
  <div
    ref="containerRef"
    class="lesson-actions"
  >
    <BtnIcon
      :icon="triggerIcon"
      view="table"
      :title="`Actions for lesson ${lesson.id}`"
      @click="toggle"
    />
    <div
      v-if="isOpen"
      ref="floatingRef"
      class="lesson-actions__floating"
      :style="floatingStyles"
    >
      <AppDropdown>
        <AppDropdownItem
          text="Edit lesson"
          color="blue"
          :prepend-icon="faPencil"
          @click="openEdit"
        />
        <AppDropdownItem
          v-if="refCanManage"
          text="Reschedule lesson"
          color="blue"
          :prepend-icon="faCalendar"
          :disabled="refIsChangeDisabled"
          @click="openReschedule"
        />
        <AppDropdownItem
          v-if="refCanApproveJoin"
          text="Approve join"
          color="blue"
          :prepend-icon="faCheck"
          @click="approveJoin"
        />
        <AppDropdownItem
          v-if="refCanViewChangelog"
          text="Show lesson changelog"
          color="blue"
          :prepend-icon="faClockRotateLeft"
          @click="openChangelog"
        />
        <AppDropdownItem
          v-if="refCanManage"
          text="Cancel lesson"
          color="red"
          :prepend-icon="faXmark"
          :disabled="refIsChangeDisabled"
          @click="openCancel"
        />
        <AppDropdownItem
          v-if="refCanDelete"
          text="Delete lesson"
          color="red"
          :prepend-icon="faTrashCan"
          :disabled="refIsDeleteDisabled"
          @click="openDelete"
        />
      </AppDropdown>
    </div>
  </div>
</template>

<style scoped lang="scss" src="./LessonActions.scss" />
